// internal
import { PermissionDataServiceType } from '../type/permission';
import { instance } from 'apps/composer-app/src/config/service';

export const getPermissions: PermissionDataServiceType = (app) => {
  return instance({
    url: `/permissions`,
    method: 'GET',
    params: { app },
  });
};
